import { request } from '@/shared/api/request'

//Убрать апи отсюда при рефакторинге кода 07.06.2023
export const getOpv = () => {
	return request({ url: 'contract/labor/getOpv', method: 'GET' })
}
